import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';
import moment from 'moment';

const useIndicatorsDay = () => {
  /* ======================================================
   * state
   * ====================================================== */
  const [indicatorList, setIndicatorList] = useState<any[]>();
  
  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();

  const searchParams = qs.parse(location.search);
  
  const { isLoading, refetch } = useQuery(
    [endpoints.management.indicators.day, [location.search]],
    () =>
      fetcher.management.postIndicatorDay({
        searchDateEnd: searchParams.searchDateEnd ? String(searchParams.searchDateEnd) : moment().add(-1, 'day').format('YYYY-MM-DD'),          
      }),
    {
      onSuccess: (res: indicatorListResDto) => {
        switch (res.code) {
          case 200:
            setIndicatorList(res.result?.list);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );


  return { indicatorList, refetch };
};

export default useIndicatorsDay;
